<script>
  import { onMount } from 'svelte';
  import sustainabilityLabelClickTracker from '../tracking/sustainabilityLabelClickTracker.js';

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

  /*                */
  let {
    labels,
    variationId,
    detailViewUrl,
    baseDetailViewUrl,
    variationDetailViewUrl,
    isMainVariation = false,
    isQueryUrl,
    tableTracking,
    featuresState = {}
  } = $props();

  let dataSheetMenuContent = $state();

  const hasFullLinksData = Boolean(
    featuresState.ENABLE_NEW_PRODUCT_LINK && baseDetailViewUrl && variationDetailViewUrl
  );

  onMount(() => {
    const textLink = 'Mehr erfahren';
    if (isMainVariation) return;
    if (hasFullLinksData) {
      dataSheetMenuContent = isQueryUrl
        ? `<oc-button-v1 base64-href=${btoa(variationDetailViewUrl)} size="100" fill-parent="" variant="primary"><a href=${baseDetailViewUrl}>${textLink}</a></oc-button-v1>`
        : `<oc-button-v1 size="100" fill-parent="" variant="primary"><a href=${variationDetailViewUrl}>${textLink}</a></oc-button-v1>`;
    } else {
      dataSheetMenuContent = `<oc-button-v1 size="100" fill-parent="" variant="primary"><a href=${detailViewUrl}>${textLink}</a></oc-button-v1>`;
    }
  });

  const clickHandler = (event) => {
    const iconContainer = event.target.closest('[data-sustainability-tag]');
    if (iconContainer === null) {
      return;
    }
    sustainabilityLabelClickTracker({
      variationId,
      tableType: tableTracking.name,
      sustainabilityTag: iconContainer.dataset.sustainabilityTag
    });
  };
</script>

{#if Array.isArray(labels) && labels.length >= 1}
  <div class="reco_comparison__multi-sustainabilities-container">
    {#each labels as label}
      <!--svelte-ignore a11y_consider_explicit_label-->
      <button
        class="reco_comparison__multi-sustainabilities-container-icon-wrapper js_openInPaliSheet"
        data-sheet-title="Was bedeutet dieses Zeichen?"
        data-sheet-url={label.descriptionUrl}
        data-sheet-menu-content={dataSheetMenuContent}
        data-sustainability-tag={label.tag}
        data-sheet-id={`${variationId}|${label.icon}`}
        onclick={clickHandler}>
        <svg class="pl_icon" role="img">
          <use href={`/assets-static/icons/` + label.icon + '.svg#' + label.icon} />
        </svg>
      </button>
    {/each}
  </div>
{/if}

<style lang="scss">
  .reco_comparison__multi-sustainabilities-container {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;

    &-icon-wrapper {
      width: 32px;
      height: 32px;
      margin-right: 4px;
      background-color: $pl_color-sustainable;
      border-radius: 50%;
      display: flex;
      align-items: center;
      border: 0;
      padding: 0 0 0 4px;

      svg {
        width: 24px;
        height: 24px;
        fill: #fff;
        cursor: pointer;
      }
    }
  }
</style>
